<app-card
	cardTitle
	cardClass="card-datatable"
	[options]="false">
	<form
		(ngSubmit)="search()"
		class="filterform">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group d-flex flex-row">
					<input
						type="text"
						class="form-control d-inline"
						name="keyword"
						[(ngModel)]="searchparams.genericSearchTerm">
					<button
						type="button"
						class="btn btn-link ml-2"
						(click)="toggleAdvanced()">
						<i class="feather icon-filter"></i>

					</button>
				</div>

			</div>
			<div class="col-md-4 mt-1">
				<div class="form-group">
					<div class="form-check form-check-inline">
						<input
							type="checkbox"
							class="form-check-input"
							name="active"
							[(ngModel)]="active">
						<label class="form-check-label">
							{{'labels.show-only-active' | translate}}
						</label>
					</div>
				</div>
			</div>

		</div>
		<div [ngbCollapse]="!showAdvancedSearch">
			<div class="row">
				<!-- fname -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.fname' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="name"
							[(ngModel)]="searchparams.likeTmp['fname']">
					</div>
				</div>
				<!-- lname -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.lname' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="lname"
							[(ngModel)]="searchparams.likeTmp['lname']">
					</div>
				</div>
				<!-- email -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.email' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="email"
							[(ngModel)]="searchparams.likeTmp['email']">
					</div>
				</div>
				<!-- utype -->
				<div
					class="col-md-4"
					*ngIf="!companyid">
					<div class="form-group">
						<label>{{'labels.type' | translate}}</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="searchparams.simpleTmp['utype']"
							name="utype">
							<option
								*ngFor="let ut of utypes"
								[value]="ut">
								{{'labels.' + ut | translate}}
							</option>
							<option value="all">{{'labels.alltypes' | translate }}</option>
						</select>
					</div>
				</div>
				<!-- company -->
				<div
					class="col-md-4"
					*ngIf="!companyid && isCompany">
					<label>{{'labels.company' | translate}}</label>

					<app-entity-autocomplete
						entityName="company"
						entityField="name"
						entityFilterType="like"
						[entitySearch]="company.search"
						name="company"
						[(ngModel)]="company.selected"
						placeholder>
					</app-entity-autocomplete>

				</div>
			</div>

		</div>
		<div class="row mt-1">
			<div class="col">
				<button
					type="submit"
					class="btn btn-primary">
					{{'labels.search' | translate}}
				</button>
				<a
					(click)="resetSearch()"
					class="btn btn-default">
					{{'labels.reset' | translate}}
				</a>
				<a
					*ngIf="false"
					[routerLink]="'new'"
					class="btn btn-primary float-right">
					{{'labels.new-user' | translate}}
				</a>
			</div>
		</div>
	</form>
</app-card>
